import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BalanceType } from 'interfaces';

export const useBallanceTypeLabels = () => {
   const { t } = useTranslation();

   const BALANCE_TYPE_LABELS: Record<BalanceType, string> = useMemo(
      () => ({
         CLIENT_LOST_OR_DESTROYED_BY_USER: t('balance.types.CLIENT_LOST_OR_DESTROYED_BY_USER'),
         CLIENT_RENTED: t('balance.types.CLIENT_RENTED'),
         CLIENT_RECEIVED_DAMAGED: t('balance.types.CLIENT_RECEIVED_DAMAGED'),
         CLIENT_DAMAGED_BY_USER: t('edit_user_balance.table.damaged_user_fault'),
         STORAGE_DAMAGED: t('edit_pallets.table.damaged'),
         STORAGE_LOST: t('storage.internal.table.lost'),
         STORAGE_READY_TO_RENT: t('storage.external.table.ready'),
         DISTRIBUTION_CENTER_FOR_COLLECTION_INVALID: t('commercial_network.table.collect_invalid'),
         DISTRIBUTION_CENTER_RETURN_INVALID: t('balance.types.DISTRIBUTION_CENTER_RETURN_INVALID'),
         DISTRIBUTION_CENTER_RETURN_VALID: t('balance.types.DISTRIBUTION_CENTER_RETURN_VALID'),
         DISTRIBUTION_CENTER_FOR_COLLECTION_VALID: t('commercial_network.table.collect_valid'),
      }),
      [t],
   );

   return { BALANCE_TYPE_LABELS };
};
